module.exports = __webpack_public_path__ + "static/media/p3.017d95f9.jpg";